<template>
    <div class="container-fluid p-5 bg-light review-card d-flex flex-column">
        <div class="review-header">
            <div class="row align-items-center mb-3">
                <div class="col-4 text-center">
                    <img src="https://faa-files.storage.googleapis.com/testimonials/review-placeholder-image.jpg"
                         alt="" class="img-fluid">
                </div>

                <div class="col-8" v-if="hasProfile">
                    <p>
                        <strong class="text-uppercase">{{ profile.firstname }} {{ profile.lastname }}</strong><br>
                        {{ profile.city }}<br>
                        {{ vehicle }}
                    </p>
                </div>

                <div class="col-8" v-else>
                    <p>
                        <strong class="text-uppercase">Anonym</strong><br>
                        Abo Kunde<br>
                        {{ vehicle }}
                    </p>
                </div>
            </div>
        </div>
        <div class="review-body">
            <div class="row mb-3 justify-content-between">
                <div class="col-auto">
                    <span>
                        <i v-for="star in fullStars" class="fas fa-star" style="color: #FFBF00;"></i>
                        <i v-for="star in emptyStars" class="fas fa-star"></i>
                    </span>
                    <h3 class="h6 text-uppercase font-weight-bold">{{ rating }}.00/5.00 {{ ratingText }}</h3>
                </div>
                <div class="col-auto justify-self-end">
                    <i class="fal fa-check-circle text-success"></i> Verifizierte Buchung</br>
                    <span class="mb-3">Bewertung vom {{ date }}</span>

                </div>
            </div>
            <p style="text-align: left;" class="mb-3">
                {{ comment }}
            </p>
        </div>

        <div class="review-footer mt-auto">
            <a href="https://www.trustedshops.de/bewertung/info_XFA7EF7E831E6775D4A31F8589EFAC1CA.html" target="_blank" class="link-alt">Profil auf Trusted Shops ansehen</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CustomerReview",
        props: {
            review: {
                type: Object,
                required: true
            }
        },
        data(){
            return {
                maxCommentLength: 200,
            };
        },
        methods: {},
        computed: {
            date(){
                let date = new Date(this.review.confirmationDate);

                let day = date.getDate();
                let monthIndex = date.getMonth() + 1;
                if(monthIndex < 10){
                    monthIndex = "0" + monthIndex;
                }
                let year = date.getFullYear();

                return day + "/" + monthIndex + "/" + year;
            },
            comment(){
                let comment = this.review.comment;
                if(comment.length > this.maxCommentLength){
                    return comment.substring(0, this.maxCommentLength) + " [...]";
                }
                return comment;
            },
            profile() {
                if (this.hasProfile) {
                    return this.review.reviewer.profile;
                } else {
                    return {};
                }
            },
            hasProfile() {
                return typeof this.review.reviewer !== "undefined";
            },
            rating() {
                return Math.round(parseFloat(this.review.mark));
            },
            ratingText() {
                let rating = "nicht verfügbar";
                if (typeof this.review.markDescriptionGUILanguage !== "undefined") {
                    rating = this.review.markDescriptionGUILanguage;
                } else {
                    let rating = this.review.markDescription;
                    switch (this.review.markDescription) {
                        case "EXCELLENT":
                            rating = "sehr gut";
                            break;
                        default:
                            rating = this.review.markDescription;
                            break;
                    }
                }
                return rating;
            },
            fullStars() {
                return this.rating;
            },
            emptyStars() {
                return 5 - this.rating;
            },
            vehicle(){
                if(typeof this.review.vehicle === 'undefined' || this.review.vehicle === null){
                    return "";
                }
                return this.review.vehicle;
            }
        }
    }
</script>

<style type="scss" scoped>
    .review-card {
        height: 100%;
    }
</style>
